/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase           from './Base';
import { useTranslation } from 'react-i18next';

export default function cardsTypeEnum(){
  const { t } = useTranslation();
  const tr = (type) => t(`card_type.${type}`);
  return new EnumBase([
    {name: tr('img_left'), id: 'img_left'},
    {name: tr('img_right'), id: 'img_right'},
    {name: tr('img_bg'), id: 'img_bg'},
    {name: tr('img_head'), id: 'img_head'}
  ]);
}
